// nav level2 hover to show level3 functionality

const level2NavItems = document.querySelectorAll('.mega-menu__link--level-2')

level2NavItems.forEach(link => {
    const linkAnchor = link.getAttribute('aria-label')
    link.addEventListener("mouseover", (event) => {
        const level3Menus = document.querySelectorAll('.level3-nav')
        level2NavItems.forEach(l => l.classList.remove('active'))
        level3Menus.forEach(l => l.classList.remove('active'))
        
        const level3ActiveNavMenu = document.querySelector(`[aria-label="level3-${linkAnchor}"]`);
        link.classList.add('active')
        level3ActiveNavMenu.classList.add('active')
    });
})

// sticky header 
$(window).scroll(() => {
    const scroll = $(window).scrollTop();
    const scrollStartHeight = $("#shopify-section-header").height();
    const header = $('#shopify-section-header');

if (scroll >= 37) {
    if (header.hasClass("fixed_nav") == false) {
        header.addClass("fixed_nav");
    }
    } else {
    header.removeClass("fixed_nav");
    }
});